import React, { memo, useCallback } from 'react';
import classNames from 'classnames';
import { useOmakasePlanSimulationChart } from 'shared-modules/services/hooks/omakasePlanLogic';
import { useDispatch } from 'react-redux';
import { useCartTermEndDate } from 'shared-modules/hooks';
import {
  OMAKASE_PLAN_SIMULATION_ROI_TEXT,
  OMAKASE_PLAN_SIMULATION_ROI_TOOLTIP,
  OMAKASE_PLAN_SIMULATION_TOTAL_PL_TEXT,
} from 'shared-modules/constants/omakasePlan';
import styles from './simulationChart.module.scss';
import { ProfitLossChart, TermSelect } from '../../../../../../../components';
import { ColoredPriceText, ColoredRateText } from '../../../../../../../components/Texts';
import { CHART_MARGIN } from '../../../../../../../screens/AutoSelect/components/SimulationChart/CommonChart';
import { openAutoSelectWarningInfo } from '../../../../../../../redux/actions';
import { InfoTooltip } from '../../../../../../../components/InfoTooltip';

const SimulationChart = () => {
  const dispatch = useDispatch();
  const { termOptions, selectedTermId, chartData, onChange, simulationData, strategyList } =
    useOmakasePlanSimulationChart();
  const termEndDate = useCartTermEndDate(strategyList);

  const handleOpenWarning = useCallback(
    () =>
      dispatch(
        openAutoSelectWarningInfo({
          termEndDate,
          isLabPreview: false,
        }),
      ),
    [dispatch, termEndDate],
  );

  return (
    <div className={styles.container}>
      <div className={styles.chartHeader}>
        <TermSelect
          titleClassName={styles.termSelectTitle}
          className={styles.termSelectContainer}
          firstButtonGap={0}
          buttonGap={24}
          options={termOptions}
          termId={selectedTermId}
          firstPaddingLeft={0}
          otherPaddingLeft={24}
          onChange={onChange}
        />

        <div className={styles.sumContainer}>
          <div className={styles.totalPlContainer}>
            <span className={styles.plText}>
              {OMAKASE_PLAN_SIMULATION_TOTAL_PL_TEXT}
              <ColoredPriceText
                value={simulationData.totalPl}
                className={styles.numberText}
                symbolClassName={styles.unitText}
              />
            </span>
          </div>

          <div className={styles.PlContainer}>
            <span className={styles.plText}>
              {OMAKASE_PLAN_SIMULATION_ROI_TEXT}
              <InfoTooltip className={styles.noPadding} message={OMAKASE_PLAN_SIMULATION_ROI_TOOLTIP} />
              <ColoredRateText
                value={simulationData.roi}
                className={styles.numberText}
                symbolClassName={styles.unitText}
              />
            </span>
          </div>

          <button type="button" className={styles.iconContainer} onClick={handleOpenWarning} aria-label="ヘルプ">
            <i className={classNames('material-icons', styles.icon)}>help_outline</i>
          </button>
        </div>
      </div>

      <div className={styles.chartContainer}>
        <ProfitLossChart chartMargin={CHART_MARGIN} data={chartData} useDefaultYAxisWidth />
      </div>
    </div>
  );
};

export default memo(SimulationChart);
